<template>
  <Modal :value="value" title="二次验证" class="vertical-center-modal tfa-modal" :width="820"
    @on-visible-change="onVisible">
    <div class="tfa">
      <div class="row steps">
        <span class="label">步骤：</span>
        <div class="steps-body">
          <p>1.下载安装“身份验证器”（Authenticator）客户端。</p>
          <p>2.身份验证器下载地址：</p>
          <p class="indent">iPhone用户下载地址（中国大陆）：<span class="link">https://itunes.apple.com/app/id1573732533</span></p>
          <p class="indent">iPhone用户下载地址（海外）：<span class="link">https://itunes.apple.com/app/id388497605</span></p>
          <p class="indent">安卓&鸿蒙用户下载地址：<span class="link">https://download3.runtietz.com/download/tools/com.tencent.authenticator_1.0.apk</span></p>
          <p>3.使用验证器“扫码二维码”功能扫描以下二维码，再输入验证器上的6位验证码，完成认证。</p>
        </div>
      </div>
      <div class="row qr">
        <span class="label">二维码：</span>
        <qrcode-block :text="otpUri" :caption="secret" :size="160" />
      </div>
      <div class="row code">
        <span class="label">二次验证码：</span>
        <Input v-model="code" placeholder="请输入谷歌验证码" maxlength="6" class="code-inp" />
      </div>
    </div>
    <template #footer>
      <dialog-footer @cancel="close" @confirm="submit" />
    </template>
  </Modal>
</template>

<script>
import QrcodeBlock from '@/components/base/QrcodeBlock.vue'

export default {
  name: 'TwoFactorDialog',
  components: { QrcodeBlock },
  props: { value: { type: Boolean, default: false } },
  data() {
    return {
      code: '',
      // 真实环境由后端下发密钥 + otpauth:// URI
      secret: 'YQVNBYX44R6NN2OQ',
      otpUri: 'otpauth://totp/MJ:tx0120?secret=YQVNBYX44R6NN2OQ&issuer=MJ'
    }
  },
  methods: {
    onVisible(v) { if (!v) this.close() },
    close() { this.code = ''; this.$emit('input', false) },
    submit() {
      if (!/^\d{6}$/.test(this.code)) { this.$Message.warning('请输入6位验证码'); return }
      this.$Message.success('二次验证已开启(待接口)')
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
.tfa .row { display: flex; margin-bottom: 20px; }
.tfa .label { flex-shrink: 0; width: 90px; text-align: right; padding-right: 10px; color: #333; }
.tfa .steps-body { color: #e4393c; line-height: 1.9; font-weight: 500; }
.tfa .steps-body p { margin: 0; }
.tfa .steps-body .indent { padding-left: 12px; }
.tfa .steps-body .link { color: #e4393c; word-break: break-all; }
.tfa .qr { align-items: flex-start; }
.tfa .code { align-items: center; }
.tfa .code-inp { flex: 1; }
</style>
